export const LOAD_DATA: string = "LOAD_DATA";
export const RESET_STORE: string = "RESET_STORE";
